<template>
	<v-rating v-model="ratingModel" :readonly="readonly" hover density="comfortable" class="global-rating">
		<template #item="props">
			<GlobalIcon
				class="global-rating__icon"
				:class="{
					'global-rating__icon--filled': colorFilled && (props.isFilled || props.isHovered),
					'global-rating__icon--empty': colorEmpty && !props.isFilled && !props.isHovered,
				}"
				:name="setIcon(props.isFilled, props.isHovered)"
				:height="16" />
		</template>
	</v-rating>
</template>

<script setup lang="ts">
const ratingModel = ref(0)

const prop = defineProps<{
	rating?: number | string
	colorFilled?: string
	colorEmpty?: string
	readonly?: boolean
}>()

const setIcon = (isFilled: boolean, isHovered?: boolean) => {
	if (prop.readonly && prop.rating === 0) return 'star-empty-color'
	return isFilled ? 'star-icon-color' : isHovered ? 'star-icon-color' : 'star-empty-color'
}

const pointerEvents = computed(() => {
	return prop.readonly ? 'none' : 'auto'
})

const emit = defineEmits<{
	(e: 'updateRating', value: number): void
}>()

watchEffect(() => {
	ratingModel.value = Math.round(prop.rating)
})

watchEffect(() => {
	if (ratingModel.value !== prop.rating) {
		emit('updateRating', ratingModel.value)
	}
})
</script>

<style lang="scss">
@import './Rating.scss';
.global-rating__icon {
	pointer-events: v-bind(pointerEvents);
}
.global-rating__icon--filled {
	color: v-bind(colorFilled);
}
.global-rating__icon--empty {
	color: v-bind(colorEmpty);
}
</style>
